// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"f8cc6998","389":"a1b99456","453":"85bd3a7d","501":"41e5a8d6","694":"0e0d98cd","903":"70b14ec5"}[chunkId] + ".chunk.js";
};